<template lang="pug">
    title-modal-layout.gdpr-request-modal(v-bind="$attrs" :title="title" :disableButtons="requestSent" @close="$emit('close')")
        template(v-slot:section)
            template(v-if="requestSent")
                .gdpr-request-modal__success
                    p Your request has been sent.
                    p Our Customer Support Representative will contact you soon.
            template(v-else)
                div GotMeHookd provides you with ways to access the information we store about you.
                br

                p.box-form-head-error(v-show="errorMessage") {{ errorMessage }}
                select-field(label="What best describes your issue?" labelShort="Issue" v-model.trim="$v.fields.issue.$model" :options="issues" :v="$v.fields.issue")

                input-box-field(label="Please enter the email address you used when registering." labelShort="Email" v-model.trim="$v.fields.email.$model" :v="$v.fields.email")
        
        template(v-slot:buttons)
            re-button.re-button--primary.re-button--sm(@click="sendRequest" :loading="sendingRequest") Send request
</template>

<script>
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import { setValidationRule, parseValidationSetup, parseValidations } from 'utils/vue/lib/validations'
import { getFirstErrorMessage } from 'utils/vue/services/main'

const VALIDATIONS = {
    issue: setValidationRule('fields.issue', {
        required: {error: 'Issue is required'},
    }),
    email: setValidationRule('fields.email', {
        required: {error: 'Email is required'},
        email: {error: 'Email is not valid'},
    }),
}

export default {
    name: 'gdpr-request-modal',

    props: {
        level: {
            type: Number,
            required: true,
        },
    },

    data() { return {
        fields: {
            issue: null,
            email: null,
        },
        requestSent: false,
        sendingRequest: false,
        validations: parseValidationSetup(VALIDATIONS, this),
        errorMessage: null,
    }},

    computed: {
        title() {
            return this.requestSent ? 'GDPR Info Request' : 'Accessing and Downloading Your GotMeHookd Information'
        },
        issues() {
            return [
                { name: 'Data access', value: 'Data access' },
                { name: 'Account access troubleshooting', value: 'Account access troubleshooting' },
                { name: 'Deactivation and deletion', value: 'Deactivation and deletion' },
                { name: 'Account ownership', value: 'Account ownership' },
            ]
        },
    },

    validations: {
        fields: parseValidations(VALIDATIONS),
    },

    created() {
        if (this.$store.getters.authUser) {
            this.fields.email = this.$store.getters.authUser.email
        }
    },

    methods: {
        async sendRequest() {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.errorMessage = null

                this.sendingRequest = true

                try {
                    await axios.post(`${window.addiesaas.config.apiUri}/customer/gdpr/info-request`, {
                        issue: this.fields.issue,
                        email: this.fields.email,
                    })

                    this.requestSent = true
                } catch (e) {
                    this.errorMessage = getFirstErrorMessage(e)
                } finally {
                    this.sendingRequest = false
                }
            }
        },

        close() {
            EventBus.$emit(Events.CLOSE_MODAL, this.level)
        }
    },
}
</script>
